import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { Customer } from '@fc-core/models';
import { ButtonComponent } from '@fc-shared/ui/buttons/button.component';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';

@Component({
  selector: 'fc-payment-notification',
  template: `
    @if (!isDismissed()) {
      <div
        class="flex flex-row fixed bottom-0 left-0 right-0 z-9999! justify-center pointer-events-none"
      >
        <div class="pointer-events-auto">
          <div
            class="fc-anim-slide-up-in shadow-lg flex flex-row gap-16 items-center justify-between p-8 rounded-2xl text-base w-full md:w-fit min-w-300 m-8 md:m-0 bg-white"
            [class.fc-anim-slide-down-out]="isLeaving()"
            (animationend)="onAnimationEnd($event)"
          >
            <div
              class="flex size-38 items-center justify-center rounded-full p-4 bg-error-50"
            >
              <fc-icon icon="icon-info-circle" color="error500" [size]="20" />
            </div>
            <div class="text-base flex-1">
              <div class="flex text-error-600 flex-wrap">
                ⚠️ Your account is past due.
                <a
                  target="_blank"
                  [href]="customer()?.paymentMethodUrl"
                  class="text-primary-600"
                >
                  &nbsp;Update your payment&nbsp;</a
                >
                within 30 days of a failed payment or your service will be
                suspended. If you have any questions
                <a
                  href="mailto:support@fleetchaser.com"
                  class="text-primary-600"
                  >&nbsp;contact us</a
                >.
              </div>
            </div>
            <fc-button
              variant="icon"
              icon="icon-close"
              (click)="isLeaving.set(true)"
            />
          </div>
        </div>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IconComponent],
})
export class PaymentNotificationComponent {
  readonly customer = input.required<Customer>();
  readonly isDismissed = signal(false);
  protected readonly isLeaving = signal(false);

  protected onAnimationEnd(event: AnimationEvent): void {
    if (event.animationName === 'fc-slide-down-out') {
      this.isDismissed.set(true);
    }
  }
}
